<div class="w-full overflow-x-auto md:m-[0] sm:mt-[2rem]">
  <div class="w-full flex justify-center">
    <div class="w-[90%] flex justify-center mt-[2rem] sm:mt-[0%]">
      <div class="search-section w-full flex flex-col sm:flex-row justify-between">
        <div
          class="sm:w-[70%] w-[95%]">
          <app-text-input
            (handleSuffixClick)="applyButtonClicked()"
            [parentFormGroup]="filterForm"
            [suffixIcon]="'search'"
            controlName="searchText"
            label="Search Questionnaire"
            placeholder="Search Questionnaire"
            type="small"
          ></app-text-input>
        </div>
        <div
          class="search-separator w-[2%] hidden sm:flex">
        </div>
        <div

          class="filter-apply-button-wrapper w-full sm:flex items-end justify-end sm:w-[25%] sm:mt-[2rem] sm-[1.5rem]">
          <app-primary-button
            (handleClick)="applyButtonClicked()"
            class="w-[95%]"
            type="small">
            Apply
          </app-primary-button>
        </div>
      </div>
    </div>
  </div>
  <div
    class="component-container flex flex-col xs:p-[2rem] sm:p-[1rem] md:p-[2.7rem] w-full"
  >
    <div
      class="table-section"
    >
      <mat-expansion-panel
        [expanded]="expandPanel"
        class="mat-elevation-z0 expansion-panel w-full"
      >
        <mat-expansion-panel-header
          class="bg-black-100 expansion-panel-header justify-center"
        >
          <div class="title">
            My Questionnaires
          </div>
        </mat-expansion-panel-header>
        <div
          (scrolled)="getNext()"
          [infiniteScrollDistance]="2"
          [infiniteScrollThrottle]="10"
          [scrollWindow]="false"
          class="table-wrapper overflow-auto xs:h-[calc(100vh-35rem)] sm:h-[calc(100vh-30rem)] md:h-[calc(100vh-30rem)]"
          infiniteScroll
        >
          <table
            (matSortChange)="sortData($event)"
            [class.hidden]="loading && isFirstPage"
            [dataSource]="dataSource"
            mat-table
            matSort
          >
            <ng-container
              [sticky]="true"
              matColumnDef="title"
            >
              <th
                *matHeaderCellDef
                class="min-w-[18rem]"
                mat-header-cell
                mat-sort-header
                id="title"
              >
                <div class="th-cell">
                  Title
                </div>
              </th>
              <td *matCellDef="let eachRow;let index=index"
                  mat-cell>
                <div class="td-cell">
                  <div class="survey-content">
                    {{eachRow?.title}}
                  </div>
                </div>
              </td>
            </ng-container>

            <ng-container
              matColumnDef="description"
            >
              <th
                *matHeaderCellDef
                class="min-w-[15rem]"
                mat-header-cell
                mat-sort-header
                id="description"
              >
                <div class="th-cell">
                  Description
                </div>
              </th>
              <td *matCellDef="let eachRow"
                  mat-cell>
                <div class="td-cell survey-content">
                  {{eachRow?.description}}
                </div>
              </td>
            </ng-container>
            <ng-container
              matColumnDef="hasTakenSurvey"
            >
              <th
                *matHeaderCellDef
                class="min-w-[15rem]"
                mat-header-cell
                mat-sort-header
                id="hasTakenSurvey"
              >
                <div class="th-cell survey-title">
                  Status
                </div>
              </th>
              <td *matCellDef="let eachRow"
                  mat-cell>
                <div class="td-cell survey-content survey-title">
                  <div
                    [ngClass]="eachRow.hasTakenSurvey ? 'completed' : 'pending'"></div>
                  {{eachRow?.hasTakenSurvey ? 'Completed' : 'Pending' }}
                </div>
              </td>
            </ng-container>
            <ng-container
              matColumnDef="view"
            >
              <th
                *matHeaderCellDef
                class="min-w-[10rem]"
                mat-header-cell
              >
                <div class="th-cell survey-status">
                </div>
              </th>
              <td *matCellDef="let eachRow"
                  mat-cell>
                <div
                  (click)="navigateToTakeSurvey(eachRow)"
                  class="td-cell clickable survey-content survey-status">
                  {{!(eachRow?.hasTakenSurvey) ? 'Take Survey' : 'Review'}}
                </div>
              </td>
            </ng-container>
            <tr *matHeaderRowDef="surveyDisplayColumn"
                mat-header-row></tr>
            <tr *matRowDef="let row; columns: surveyDisplayColumn;"
                mat-row></tr>
          </table>
          <div *ngIf="loading"
               [ngClass]="{ 'initial': !dataSource.data?.length }"
               class="table-loader w-full flex justify-center items-center">
            <mat-spinner/>
          </div>
          <div
            *ngIf="!dataSource.data?.length && !loading"
            class="no-data flex flex-col justify-center items-center"
          >
            <div class="text">
              No Data Found
            </div>
          </div>
        </div>
      </mat-expansion-panel>
    </div>
  </div>
</div>
